import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {setGetCountOnline} from '../../store/thunk/setGetCountOnline';

const CountOnline = ({users}) => {
    return (
        <div>
            <span style={{color: '#fff', textTransform: 'uppercase', fontSize: 20}}><span style={{color: '#3cde0b', fontWeight: 700}}>{users?.count}</span> человек сейчас онлайн</span>
        </div>
    )
}

export default CountOnline;